import axios, { ResponseType } from "axios";

const beneficiosService =
{    
    getBeneficios: async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + '/api/User/getBeneficios');
            return response.data;
        } catch (error: any) {
            console.log("Error ", error.response ? error.response.data : error.message);
        }
    },

    // Listado de recibos (para la pantalla de ReciboDeHaberes)
    getRecibosAfiliado: async (
        IdBeneficiario: number,
        TipoBeneficiario: number,
        Periodo?: string,
        TipoLiquidacion?: number,
        FechaDesde?: string | null,
        FechaHasta?: string | null
    ) => {
        try {            
            // PascalCase obligatorio para que el backend lo acepte
            const body = {
                IdBeneficiario,
                TipoBeneficiario,
                TipoLiquidacion: TipoLiquidacion ?? 1, // default si no lo pasás
                Periodo: Periodo ?? null,
                FechaDesde: FechaDesde ?? null,
                FechaHasta: FechaHasta ?? null,
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/Beneficiario/getRecibosBeneficiario`,
                body
            );

            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    // Para Android/iOS → descarga un recibo en ArrayBuffer
    getReciboAfiliado: async (
        idBeneficiario: number,
        idTipoBeneficio: number,
        periodo: string
    ) => {
        try {          
            const config = {
                responseType: "arraybuffer" as ResponseType,
            };
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Beneficiario/getReciboBeneficiario`,
                {
                    params: { idBeneficiario, idTipoBeneficio, periodo },
                    ...config,
                }
            );

            return response.data; // ArrayBuffer
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    // Para Web → devuelve base64
    getReciboAfiliadoWeb: async (
        idBeneficiario: number,
        idTipoBeneficio: number,
        periodo: string
    ) => {
        try {                       
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Beneficiario/getReciboBeneficiario`,
                {
                    params: { idBeneficiario, idTipoBeneficio, periodo }                    
                }
            );

            return response.data; // JSON ya parseado, contiene base64
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    // Supervivencias
    getSupervivencias: async (idBeneficiario: number, idTipoBeneficio: number) => {
        try {
           
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Beneficiario/getSupervivencias`,
                {
                    params: { idBeneficiario, idTipoBeneficio }
                }
            );

            return response.data; // { success, data, errors }
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
};

export default beneficiosService
